import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Printer, RotateCcw } from 'lucide-react'

function ResultsFooter({ onRestart }) {
  const [confirm, setConfirm] = useState(false)

  useEffect(() => {
    if (!confirm) return undefined
    const t = window.setTimeout(() => setConfirm(false), 4000)
    return () => window.clearTimeout(t)
  }, [confirm])

  return (
    <footer className="results__foot">
      <div className="results__foot-actions">
        <button type="button" className="btn btn--secondary" onClick={() => window.print()}>
          <Printer size={16} strokeWidth={2} />
          Print
        </button>
        <button
          type="button"
          className={`btn ${confirm ? 'btn--accent' : 'btn--secondary'}`}
          onClick={() => (confirm ? onRestart() : setConfirm(true))}
        >
          <RotateCcw size={16} strokeWidth={2} />
          {confirm ? 'Confirm: clear and start over' : 'Start a new assessment'}
        </button>
      </div>
      <p className="disclaimer">
        This readout is information, not a diagnosis. If you are in distress or thinking about harming yourself, contact a healthcare professional or your local emergency number now.
      </p>
      <p className="results__meta">
        <span>BetterStep</span>
        <span>betterstep.io</span>
      </p>
    </footer>
  )
}

ResultsFooter.propTypes = {
  onRestart: PropTypes.func.isRequired,
}

export default ResultsFooter
